import React, { useState } from 'react';
import codeGif from './assets/skillsicon.gif';
import './css/Skills.css';

const Skills = () => {

  const [activeCategory, setActiveCategory] = useState(null);

  const categories = [
    {
      id: 'frontend',
      label: 'Frontend',
      accent: '#6d56ff',
      glow: 'rgba(109, 86, 255, 0.35)',
      border: 'rgba(109, 86, 255, 0.5)',
      skills: [
        { name: "TypeScript" },
        { name: "JavaScript (ES6+)" },
        { name: "React" },
        { name: "Angular" },
        { name: "RxJS" },
        { name: "Jest" },
        { name: "Micro Frontends" },
        { name: "Component-Driven Architecture" },
        { name: "Server-Driven UI" },
        { name: "Real-Time Systems (WebSockets)" },
        { name: "Web Performance Optimization" },
        { name: "Core Web Vitals (LCP, TTFB)" },
      ]
    },
    {
      id: 'backend',
      label: 'Backend',
      accent: '#00c9a7',
      glow: 'rgba(0, 201, 167, 0.35)',
      border: 'rgba(0, 201, 167, 0.5)',
      skills: [
        { name: "Node.js" },
        { name: "Express.js" },
        { name: "REST API Design" },
        { name: "Middleware Engineering" },
        { name: "Authentication & Authorization (JWT)" },
        { name: "Microservices Architecture" },
        { name: "Event-Driven Architecture" },
        { name: "Redis (Caching & Distributed State)" },
        { name: "Token Bucket Rate Limiting" },
        { name: "Observability & Metrics (Prometheus)" },
        { name: "Database Design (SQL Server)" },
        { name: "API Performance Optimization" },
      ]
    },
    {
      id: 'systems',
      label: 'Systems & DevOps',
      accent: '#ff7e3b',
      glow: 'rgba(255, 126, 59, 0.35)',
      border: 'rgba(255, 126, 59, 0.5)',
      skills: [
        { name: "Distributed Systems" },
        { name: "System Design" },
        { name: "Operating Systems" },
        { name: "Computer Networks" },
        { name: "Data Structures & Algorithms" },
        { name: "Scalable Architecture Design" },
        { name: "Fault-Tolerant System Thinking" },
        { name: "Docker (Containerization)" },
        { name: "CI/CD Pipelines" },
        { name: "Production-Grade Engineering" },
        { name: "Full SDLC Ownership" },
      ]
    }
  ];

  return (
    <>


      <section className="Skills" id="skills">

        {/* ── Title ── */}
        <div className="skillsTitle d-flex">
          <h3>Technical Skills</h3>
          <img src={codeGif} alt="skills" />
        </div>

        {/* ── 3-Column Grid ── */}
        <div className="skills-grid">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="skill-category-card"
              style={{
                borderColor: `rgba(${hexToRgb(cat.accent)}, 0.22)`,
                boxShadow: `0 0 40px ${cat.glow.replace('0.35', '0.08')}, inset 0 1px 0 rgba(255,255,255,0.04)`,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.boxShadow = `0 8px 50px ${cat.glow}, inset 0 1px 0 rgba(255,255,255,0.06)`;
                e.currentTarget.style.borderColor = cat.border;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.boxShadow = `0 0 40px ${cat.glow.replace('0.35', '0.08')}, inset 0 1px 0 rgba(255,255,255,0.04)`;
                e.currentTarget.style.borderColor = `rgba(${hexToRgb(cat.accent)}, 0.22)`;
              }}
            >
              {/* Header — always visible */}
              <div className="skill-category-header">
                <span
                  className="category-dot"
                  style={{
                    background: cat.accent,
                    boxShadow: `0 0 8px ${cat.accent}`,
                  }}
                />
                <h6
                  className="category-title"
                  style={{ color: cat.accent }}
                >
                  {cat.label}
                </h6>
                <span className="category-count">
                  {cat.skills.length} skills
                </span>
              </div>

              {/* Skills — always visible as pills */}
              <div className="skill-pills">
                {cat.skills.map((skill, i) => (
                  <span
                    key={i}
                    className="skill-pill"
                    style={{
                      '--pill-accent': cat.accent,
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.borderColor = `rgba(${hexToRgb(cat.accent)}, 0.5)`;
                      e.currentTarget.style.color = cat.accent;
                      e.currentTarget.style.background = `rgba(${hexToRgb(cat.accent)}, 0.08)`;
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.09)';
                      e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                      e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
                    }}
                  >
                    {skill.name}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

      </section>
    </>
  );
};

// Helper — convert hex to "r, g, b" for rgba()
function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '255,255,255';
  return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
}

export default Skills;